import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./auth/AuthContext";
import { RouterProvider } from "./router";
import { App } from "./App";
import { inicializarTema } from "./theme";

// El script inline en index.html ya aplicó el tema guardado (si existe)
// antes de este punto, para evitar parpadeo visual. Esto solo confirma que
// las variables CSS quedan sincronizadas con localStorage (p. ej. si no
// había tema guardado, aplica el de por defecto explícitamente).
inicializarTema();

const contenedor = document.getElementById("root");
if (!contenedor) {
  throw new Error("No se encontró el elemento #root en index.html");
}

createRoot(contenedor).render(
  <React.StrictMode>
    <RouterProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </RouterProvider>
  </React.StrictMode>
);
